import { createContext, useState } from "react";
import { logoutAdmin } from "../api/adminApi";

export const AuthContext = createContext();

const getStoredAdmin = () => {
  const stored = localStorage.getItem("admin");

  if (stored && stored !== "undefined") {
    try {
      return JSON.parse(stored);
    } catch (error) {
      console.error("Failed to parse admin from localStorage", error);
      return null;
    }
  }
  return null;
};

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(getStoredAdmin());
  const [token, setToken] = useState(localStorage.getItem("admin_access_token") || null);

  const login = (data) => {
    setAdmin(data.admin);
    setToken(data.access_token);

    // Save separated dual-tokens securely
    localStorage.setItem("admin_access_token", data.access_token);
    localStorage.setItem("admin_refresh_token", data.refresh_token);
    localStorage.setItem("admin", JSON.stringify(data.admin));
  };

  const logout = async () => {
    // Graceful backend cleanup block
    try {
      const currentToken = localStorage.getItem("admin_access_token");
      if (currentToken) {
        // Explicitly clear family tokens at server-level
        await logoutAdmin();
      }
    } catch (error) {
      console.log("Backend token invalidation completed or already expired.");
    }

    setAdmin(null);
    setToken(null);

    localStorage.removeItem("admin_access_token");
    localStorage.removeItem("admin_refresh_token");
    localStorage.removeItem("admin");

    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider
      value={{
        admin,
        token,
        login,
        logout
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};